import { type InsuranceCorporateIdentity } from "../types";

export function TechnoformLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M178.808 308.561H75.391V205.131H178.808V308.561Z"
        stroke="#575756"
        strokeWidth="0.9991"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M307.908 308.561H204.472V205.131H307.908V308.561Z"
        fill="#194383"
      />
      <path
        d="M307.908 308.561H204.472V205.131H307.908V308.561Z"
        stroke="#194383"
        strokeWidth="0.9991"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M437 437.042H333.574V333.611H437V437.042Z" fill="#194383" />
      <path
        d="M437 437.042H333.574V333.611H437V437.042Z"
        stroke="#194383"
        strokeWidth="0.9991"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M437 308.561H333.574V205.131H437V308.561Z" fill="#194383" />
      <path
        d="M437 308.561H333.574V205.131H437V308.561Z"
        stroke="#194383"
        strokeWidth="0.9991"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.808 437.042H75.391V333.611H178.808V437.042ZM307.908 437.042H204.474V333.611H307.908V437.042Z"
        stroke="#575756"
        strokeWidth="0.9991"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M437 180.064H333.574V76.6399H437V180.064Z" fill="#194383" />
    </svg>
  );
}

export const Technoform: InsuranceCorporateIdentity = {
  id: "technoform",
  name: "Technoform",
  logo: TechnoformLogo,
  backgroundColor: "white",
  textColor: "#000000",
  wildcard: "technoform",
  type: "statutory",
};
